// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-select-container {
  position: relative;
}

.custom-select_label {
  position: absolute;
  top: -30px;
  left: 20px;
  color: #a2a2a2;
}

.table-selectors {
  margin-right: 30px;
  width: 300px;
}

@media screen  and (max-width: 1400px) and (min-width: 913px) {
  .custom-select-container:nth-child(3) {
    margin-top: 50px;
  }
}

@media screen  and (max-width: 910px) {
  .custom-select-container {
    margin-top: 50px;
  }

  .custom-select_label {
    top: -25px;
  }

  .table-selectors {
    margin-right: 0;
    width: 400px;
  }
}

@media screen  and (max-width: 520px) {
  .custom-select-container {
    margin-top: 50px;
  }

  .custom-select_label {
    top: -25px;
  }

  .table-selectors {
    margin-right: 0;
    width: 400px;
  }
}

@media screen  and ( max-width: 450px) {
  .table-selectors {
    margin-right: 0;
    width: 320px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomSelect/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;EACd;AACF","sourcesContent":[".custom-select-container {\n  position: relative;\n}\n\n.custom-select_label {\n  position: absolute;\n  top: -30px;\n  left: 20px;\n  color: #a2a2a2;\n}\n\n.table-selectors {\n  margin-right: 30px;\n  width: 300px;\n}\n\n@media screen  and (max-width: 1400px) and (min-width: 913px) {\n  .custom-select-container:nth-child(3) {\n    margin-top: 50px;\n  }\n}\n\n@media screen  and (max-width: 910px) {\n  .custom-select-container {\n    margin-top: 50px;\n  }\n\n  .custom-select_label {\n    top: -25px;\n  }\n\n  .table-selectors {\n    margin-right: 0;\n    width: 400px;\n  }\n}\n\n@media screen  and (max-width: 520px) {\n  .custom-select-container {\n    margin-top: 50px;\n  }\n\n  .custom-select_label {\n    top: -25px;\n  }\n\n  .table-selectors {\n    margin-right: 0;\n    width: 400px;\n  }\n}\n\n@media screen  and ( max-width: 450px) {\n  .table-selectors {\n    margin-right: 0;\n    width: 320px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
